/**
 * Button Click Event Builder
 * Factory function to create button_click dataLayer events
 */

import { ButtonClick, ButtonClickEventOf, GaEventType } from '../types/index.js';
import { buildBaseEvent } from './base-event-builder.js';

/**
 * Build a button_click event.
 *
 * The generic parameter (rather than a plain `ButtonClick` argument) suppresses
 * TypeScript's excess-property check, so apps can pass their own extension
 * fields and have them snake-cased onto the event — and it is carried into the
 * return type, so those fields are readable off the result without a cast. See
 * the extension-field test in button-click-event-builder.spec.ts.
 */
export function buildButtonClickEvent<T extends ButtonClick>(options: T): ButtonClickEventOf<T> {
    return buildBaseEvent<ButtonClickEventOf<T>>(GaEventType.ButtonClick, options);
}
